/* global I18n  */

import React from "react"

function VisitorCTA() {
  return (
    <div className="demo-summary-cta">
      <div className="headline">
        {I18n.t("js.embedded_quiz.visitor_summary.headline")}
      </div>
      <a
        className="btn btn-primary"
        href={window.gon.new_user_registration_path}
        data-track="registration clicked"
        data-track-element="quiz summary">
        {I18n.t("js.embedded_quiz.visitor_summary.primaty_cta")}
      </a>
      <p className="tiny">
        {I18n.t("js.embedded_quiz.visitor_summary.more_info")}
      </p>
      <a
        className="demo-summary-cta__non-cta"
        href="http://www.spinedu.com/textbooks-boring-students-death"
        target="blank">
        {I18n.t("js.embedded_quiz.visitor_summary.exit_cta")}
      </a>
    </div>
  )
}

export default VisitorCTA
